export function getFullName(
  first_name: string | null,
  last_name: string | null
): string {
  // If either name is null or an empty string, replace it with an empty string
  first_name = first_name ? first_name : "";
  last_name = last_name ? last_name : "";

  // Remove leading or trailing spaces
  const full_name = `${first_name} ${last_name}`.trim();

  return full_name;
}
